import FVector from '@data/geometry/FVector';
import { BuildingSource, PreProcessingTypes } from '@visualizer/types';
import type { GeoEditManager } from './GeoEditManager';
import { addExtrudedBuildingFromPolygon } from './addExtrudedBuilding';

export function addProjectSketchFromPolygon(args: {
    editManager: GeoEditManager;
    points: FVector[];
    height: number;
    elevation: number;
    flatTop: boolean;
}) {
    addExtrudedBuildingFromPolygon({
        ...args,
        source: BuildingSource.SKETCH,
        groupTypes: {
            floor: PreProcessingTypes.PROJECT_SKETCH_FLOOR,
            roof: PreProcessingTypes.PROJECT_SKETCH_ROOF,
            wall: PreProcessingTypes.PROJECT_SKETCH_WALL,
        },
    });
}
